import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppUser } from "../../modules/shared/app-user";
import { AuthActions } from "../../auth/store/actions";
import { Strings } from "../../../strings/strings";
import { FilterStorageService } from "../../services/filter-storage/filter-storage.service";
import { RedirectorService } from "../../auth/services/redirector.service";
@Component({
    selector: "app-logout",
    templateUrl: "./logout.component.html",
    standalone: false,
})
export class LogoutComponent {
    strings = Strings;
    signoutMessage?: string;
    constructor(
        private globalStore: Store<{ appUser: AppUser }>,
        private filterStorageService: FilterStorageService,
        private redirectorService: RedirectorService,
    ) {
        this.filterStorageService.clear();
    }
    ngOnInit() {
        this.signoutMessage = this.redirectorService.errorMsg ?? "You have been logged out";
    }

    login(): void {
        this.globalStore.dispatch(AuthActions.login({}));
    }
}
